import { useEffect, useRef, useState } from "react";
import { useReducedMotion } from "@/lib/useReducedMotion";

// Apparition en fondu, 100 % CSS + IntersectionObserver (aucune lib d'animation).
// Le contenu déjà visible au montage est révélé immédiatement (évite les pages
// « blanches ») ; le reste apparaît au scroll, avec repli de sécurité à 1,2 s.
export const Reveal = ({ children, delay = 0, className = "" }) => {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (reduce) { setShow(true); return () => {}; }
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") { setShow(true); return () => {}; }

    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) { setShow(true); return () => {}; }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { setShow(true); io.disconnect(); }
        });
      },
      { rootMargin: "0px 0px -60px 0px" }
    );
    io.observe(el);

    const t = setTimeout(() => setShow(true), 1200);
    return () => { io.disconnect(); clearTimeout(t); };
  }, [reduce]);

  const style = reduce
    ? undefined
    : {
        opacity: show ? 1 : 0,
        transform: show ? "translateY(0)" : "translateY(14px)",
        transition: `opacity 1.4s ease-out ${delay}s, transform 1.4s ease-out ${delay}s`,
        willChange: "opacity, transform",
      };

  return (
    <div ref={ref} className={className} style={style}>
      {children}
    </div>
  );
};
